import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

// import Vueform from '@vueform/vueform'
import vueformConfig from './../vueform.config'

import App from './App.vue'
import router from './router'
import piniaPersist from 'pinia-plugin-persist'
import Vueform, {
  // Essential form components
  FormErrors,
  FormMessages,

  // Essential element components
  ElementLayout,
  ElementLoader,
  ElementLabelFloating,
  ElementLabel,
  ElementError,
  ElementDescription,
  ElementMessage,
  ElementInfo,
  ElementRequired,

  // Optional form components
  FormLanguages,
  FormLanguage,
  FormSteps,
  FormStepsControls,
  FormStepsControl,
  FormStep,

  // Elements
  ButtonElement,
  SelectElement,
  SliderElement,
  StaticElement,
  TextElement,
  ElementText,
  ElementAddon,
  HiddenElement
} from '@vueform/vueform/src/core.js'

import * as Sentry from '@sentry/vue'

const app = createApp(App)

const pinia = createPinia()
pinia.use(piniaPersist)

Sentry.init({
  app,
  dsn: 'https://546d1abe05b1aa4dcd78e77f85c45e10@o4504565225881600.ingest.us.sentry.io/4507017717088256',
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.captureConsoleIntegration(),
    Sentry.httpClientIntegration()
  ],
  tracesSampleRate: 0.1
})

app.use(pinia)
app.use(router)
// app.use(Vueform, vueformConfig)
app.use(Vueform, {
  ...vueformConfig,
  components: {
    FormErrors,
    FormMessages,
    ElementLayout,
    ElementLoader,
    ElementLabelFloating,
    ElementLabel,
    ElementError,
    ElementAddon,
    ElementDescription,
    ElementMessage,
    ElementInfo,
    ElementRequired,
    FormLanguages,
    ElementText,
    FormLanguage,
    FormSteps,
    FormStepsControls,
    FormStepsControl,
    FormStep,
    ButtonElement,
    SelectElement,
    SliderElement,
    StaticElement,
    HiddenElement,
    TextElement
  }
})

app.mount('#app')
